'use strict';

angular.module('bringgApp.directives').directive('keyTrap', function () {
	return function (scope, elem) {
		elem.bind('keydown', function (event) {
			scope.$broadcast('keydown', event.keyCode);
		});
	};
});
